import { createMediaFrame } from '@wix/media-frame';

(window as any).MediaFrame = createMediaFrame(); //needed for media-manager-api
